import axios, {AxiosRequestConfig} from "axios";
import {Endpoints, EndpointsNew} from "./Endpoints";
import {
    FeaturedInputModel,
    LoginModel,
    LoginModelNew,
    ProducerModelQueryParams,
    ProducerModelQueryParamsNew,
    ProducerRegistrationModelQueryParamsNew,
    UserModelQueryParamsNew
} from "../model/Producer";
import {CategoryQueryParams, CategoryQueryParamsNew} from "../model/Category";
import {ProductQueryParams, VariantModelNew} from "../model/Product";
import {EventQueryParams, EventQueryParamsNew} from "../model/Event";
import {LotModelNew} from "../model/Lot";
import {BASE_FILE_URL, BASE_URL, IS_SMARTVENUES, notEmptyOrUndefined} from "../../utils/Utils";
import {LoginResponseNew} from "../model/LoginResponse";
import {MediaParamsNew} from "../model/MediaModel";
import {OrderStatusInput} from "../model/ui/OrderModel";
import {OrderRecord} from "../../components/organisms/OrdersAdmin/OrdersAdmin";
import {ShippingFormData} from "../../components/organisms/BillingEdit/BillingEdit";

axios.interceptors.response.use(
    response => response, // se non c'è errore, restituisci semplicemente la risposta
    async error => {
        if (error.response && error.response.status === 401) {
            const email = localStorage.getItem('username');
            const password = localStorage.getItem('password');

            if (email && password) {
                try {
                    const res = await loginNew({email, password});
                    if (res?.status === 200) {
                        const response = res?.data as LoginResponseNew;
                        const newToken = response.data?.accessToken;

                        console.log(newToken);

                        if (!newToken) {
                            window.location.href = '/landing';
                        } else {
                            localStorage.setItem('tokenNew', newToken || '');

                            axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

                            return axios(error.config);
                        }
                    }
                } catch (loginError) {
                    console.error('Errore durante il login:', loginError);
                    // return Promise.reject(loginError);
                    window.location.href = '/landing';
                    return Promise.reject(loginError);
                }
            } else {
                window.location.href = '/landing';
            }
        }
        // window.location.href = '/landing';
        return Promise.reject(error);
    }
);

export async function baseCallNew<T>({method, endpoint, data, id, hasToken = true, params, headersExt}: {
    method?: 'POST' | 'GET' | 'PUT' | 'DELETE',
    endpoint?: EndpointsNew,
    data?: T,
    id?: number | string,
    hasToken?: boolean,
    params?: Record<string, any>,
    headersExt?: Record<string, any>
}) {
    const url = `${BASE_URL}/${endpoint}${id ? `/${id}` : ''}`;
    const token = localStorage.getItem('tokenNew');

    const baseHeaders: Record<string, string> = {};
    if (token) {
        baseHeaders.Authorization = `Bearer ${token}`;
        baseHeaders['X-Tenant'] = IS_SMARTVENUES ? 'smartvenues' : 'enoteca';
    }
    if (headersExt) {
        Object.assign(baseHeaders, headersExt);
    }

    const config: AxiosRequestConfig = {
        url,
        method,
        params,
        data,
        headers: baseHeaders
    };

    try {
        return await axios(config);
    } catch (e) {
        console.error(e);
        return undefined;
    }
}

/*export async function baseCallNew<T>({method, endpoint, data, id, hasToken = true, params, headersExt}: {
    method?: "POST" | "GET" | "PUT" | "DELETE",
    endpoint?: EndpointsNew,
    data?: T,
    id?: number | string,
    hasToken?: boolean,
    params?: Record<string, any>,
    headersExt?: Record<string, any>,
}) {
    try {
        // const url = `${BASE_URL}/${endpoint}${!!id ? `/${id}` : ''}`; TODO !!!!!
        const url = `${BASE_URL}/${endpoint}${!!id ? `/${id}` : ''}`;
        // console.log(`url => ${url}`);

        // const url = "https://ed1d-2001-b07-646b-f5d8-a52d-a647-9919-a8d0.ngrok-free.app";
        const token = localStorage.getItem("tokenNew");

        let headers: { Authorization: string, 'X-Tenant': string } | undefined = undefined;
        if (token) {
            headers = {
                ...headersExt,
                Authorization: `Bearer ${token}`,
                'X-Tenant': IS_SMARTVENUES ? "smartvenues" : "enoteca"
            };
        }

        const config: AxiosRequestConfig = {
            url,
            method,
            data,
            headers: data instanceof FormData ? {Authorization: `Bearer ${token}`} : headers,
            params,
        };

        return axios(config);
    } catch (e) {
        console.error(e);
        return undefined;
    }
}*/

export async function baseCall<T>(
    {type = "WC", method = "GET", endpoint, data, id, hasAuth = false, params}: {
        type?: "WP" | "WC" | "RESTAPI",
        method?: "POST" | "GET" | "PUT" | "DELETE",
        endpoint?: Endpoints,
        data?: T,
        id?: number | string,
        hasAuth?: boolean,
        params?: Record<string, any>
    }
) {
    const service = type === "RESTAPI" ? `restapi` : type === "WP" ? `wp/${process.env.REACT_APP_WP_VERSION}` : `wc/${process.env.REACT_APP_WC_VERSION}`;
    try {
        const url = `${process.env.REACT_APP_BASE_URL}/${service}/${endpoint}${!!id ? `/${id}` : ''}`;

        const auth = hasAuth ? {
            username: (type === "WC" ? process.env.REACT_APP_WC_USERNAME : process.env.REACT_APP_WP_USERNAME) || "",
            password: (type === "WC" ? process.env.REACT_APP_WC_PASSWORD : process.env.REACT_APP_WP_PASSWORD) || ""
        } : undefined

        const token = localStorage.getItem("token");

        let headers: { Authorization: string } | undefined = undefined;

        if (token && !hasAuth)
            headers = token ? {
                Authorization: `Bearer ${token}`
            } : undefined;

        return axios({url, method, data, auth, headers, params});
    } catch (e) {
        console.error(e);
        return undefined;
    }
}

export async function ping() {
    return baseCall({
        type: "RESTAPI",
        endpoint: Endpoints.ping
    });
}

export async function login(data: LoginModel) {
    try {
        const url = `${process.env.REACT_APP_BASE_URL}/jwt-auth/v1/token`;

        const baseHeaders: Record<string, string> = {};
        baseHeaders['X-Tenant'] = IS_SMARTVENUES ? 'smartvenues' : 'enoteca';

        return axios({url, method: "POST", data, headers: baseHeaders});
    } catch (e) {
        console.error(e);
        return undefined;
    }
}

export async function loginNew(data: LoginModelNew) {
    // TODO: !!!!
    // const baseurl = localStorage.getItem("baseurl") || "";
    // TODO: !!!! end

    try {
        // const url = `${BASE_URL}/login`; TODO: !!!!
        const url = `${BASE_URL}/login`;

        const baseHeaders: Record<string, string> = {};
        baseHeaders['X-Tenant'] = IS_SMARTVENUES ? 'smartvenues' : 'enoteca';

        return axios({url, method: "POST", data, headers: baseHeaders});
    } catch (e) {
        console.error(e);
    }
}

export async function getUserProducerId() {
    return baseCall({
        type: "RESTAPI",
        endpoint: Endpoints.userProducerId
    });
}

export async function addCategory(data: CategoryQueryParams) {
    return baseCall({
        endpoint: Endpoints.category,
        type: "RESTAPI",
        method: "POST",
        data: data
    });
}

export async function addLotNew(data: LotModelNew) {
    return baseCallNew({
        endpoint: EndpointsNew.product_lot,
        method: "POST",
        data
    })
}

export async function editLotNew(id: string, data: LotModelNew) {
    return baseCallNew({
        endpoint: EndpointsNew.product_lot,
        method: "PUT",
        data,
        id
    })
}

export async function editOrder(params: OrderStatusInput) {
    return baseCallNew({
        endpoint: EndpointsNew.order_status,
        method: "PUT",
        params,
    });
}

export async function editShipping(params: ShippingFormData) {
    return baseCallNew({
        endpoint: EndpointsNew.shippings,
        method: "PUT",
        data: params,
        id: params.id,
    });
}

export async function getOrderById(id: string) {
    return baseCallNew<OrderRecord>({
        endpoint: EndpointsNew.orders,
        method: "GET",
        id,
    });
}

export async function addCategoryNew(data: CategoryQueryParamsNew) {
    return baseCallNew({
        endpoint: EndpointsNew.categories,
        method: "POST",
        headersExt: {
            'Content-Type': 'multipart/form-data'
        },
        params: {
            name: data.name,
            description: data.description,
            parentCategoryId: data.parentId,
            image: data.image,
        }
    });
}

export async function addMediaPhp(
    file: File | null | undefined
) {
    let mediaPath: string | undefined

    if (file) {
        const phpForm = new FormData()
        phpForm.append("file", file)

        const phpResp = await fetch(
            `${BASE_FILE_URL}/upload_file.php`,
            {
                method: "POST",
                headers: {
                    Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJEaWFyaW8gZGkgYm9yZG8iLCJpYXQiOjE3NDM2MTA3NzYsImV4cCI6MTc3NTE0NjgyNCwiYXVkIjoiZGlhcmlvZGlib3Jkby5hZ2VzY2lzaWNpbGlhLml0Iiwic3ViIjoiRGlhcmlvIGRpIGJvcmRvIn0.VYNE3EzENrOELmbFtO3wCK_K8tLnPl6bCvEMWGATRho"
                },
                body: phpForm
            }
        )

        const phpJson = (await phpResp.json()) as PhpUploadResponse
        if (!phpJson.success || !phpJson.public_url) {
            throw new Error(
                "Upload PHP fallito: " + (phpJson.error || phpResp.statusText)
            )
        }
        mediaPath = phpJson.public_url
    }

    return mediaPath
}

export async function addMediaProducerNew(
    params: MediaParamsNew,
    file: File | null
) {
    let mediaPath: string | undefined

    if (file) {
        const phpForm = new FormData()
        phpForm.append("file", file)

        const phpResp = await fetch(
            `${BASE_FILE_URL}/upload_file.php`,
            {
                method: "POST",
                headers: {
                    Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJEaWFyaW8gZGkgYm9yZG8iLCJpYXQiOjE3NDM2MTA3NzYsImV4cCI6MTc3NTE0NjgyNCwiYXVkIjoiZGlhcmlvZGlib3Jkby5hZ2VzY2lzaWNpbGlhLml0Iiwic3ViIjoiRGlhcmlvIGRpIGJvcmRvIn0.VYNE3EzENrOELmbFtO3wCK_K8tLnPl6bCvEMWGATRho"
                },
                body: phpForm
            }
        )

        const phpJson = (await phpResp.json()) as PhpUploadResponse
        if (!phpJson.success || !phpJson.public_url) {
            throw new Error(
                "Upload PHP fallito: " + (phpJson.error || phpResp.statusText)
            )
        }
        mediaPath = phpJson.public_url
    }

    const finalParams = {
        ...params,
        ...(mediaPath ? {mediaPath} : {})
    }

    return baseCallNew({
        endpoint: EndpointsNew.media_producer,
        method: "POST",
        params: finalParams,
    })
}

export async function addMediaNew(
    params: MediaParamsNew,
    file: File | null
) {
    let mediaPath: string | undefined

    if (file) {
        const phpForm = new FormData()
        phpForm.append("file", file)

        const phpResp = await fetch(
            `${BASE_FILE_URL}/upload_file.php`,
            {
                method: "POST",
                headers: {
                    Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJEaWFyaW8gZGkgYm9yZG8iLCJpYXQiOjE3NDM2MTA3NzYsImV4cCI6MTc3NTE0NjgyNCwiYXVkIjoiZGlhcmlvZGlib3Jkby5hZ2VzY2lzaWNpbGlhLml0Iiwic3ViIjoiRGlhcmlvIGRpIGJvcmRvIn0.VYNE3EzENrOELmbFtO3wCK_K8tLnPl6bCvEMWGATRho"
                },
                body: phpForm
            }
        )

        const phpJson = (await phpResp.json()) as PhpUploadResponse
        if (!phpJson.success || !phpJson.public_url) {
            throw new Error(
                "Upload PHP fallito: " + (phpJson.error || phpResp.statusText)
            )
        }
        mediaPath = phpJson.public_url
    }

    const finalParams = {
        ...params,
        ...(mediaPath ? {mediaPath} : {})
    }

    return baseCallNew({
        endpoint: EndpointsNew.media,
        method: "POST",
        params: finalParams,
    })
}

export async function deleteMediaFromServer(fileUrl: string) {
    const resp = await fetch(
        `${BASE_FILE_URL}/remove_file.php`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJEaWFyaW8gZGkgYm9yZG8iLCJpYXQiOjE3NDM2MTA3NzYsImV4cCI6MTc3NTE0NjgyNCwiYXVkIjoiZGlhcmlvZGlib3Jkby5hZ2VzY2lzaWNpbGlhLml0Iiwic3ViIjoiRGlhcmlvIGRpIGJvcmRvIn0.VYNE3EzENrOELmbFtO3wCK_K8tLnPl6bCvEMWGATRho"
            },
            body: JSON.stringify({
                fileName: fileUrl
            })
        }
    )

    const json = await resp.json()
    if (!json.success) {
        throw new Error("Eliminazione fallita: " + (json.error || resp.statusText))
    }

    return json.message
}

interface PhpUploadResponse {
    success: boolean
    public_url?: string
    error?: string
}

export async function editVariantNew(id: string, data: VariantModelNew) {
    return baseCallNew({
        endpoint: EndpointsNew.variant,
        method: "PUT",
        data,
        id
    });
}

export async function verifyEmail(email: string, code: string) {
    return baseCallNew({
        endpoint: EndpointsNew.verify_email,
        method: "GET",
        params: {
            email,
            code
        }
    });
}

export async function deleteVariantNew(id: string) {
    return baseCallNew({
        endpoint: EndpointsNew.variant,
        method: "DELETE",
        id
    });
}

export async function editCategoryNew(id: string, data: CategoryQueryParamsNew) {
    return baseCallNew({
        endpoint: EndpointsNew.categories,
        method: "PUT",
        id,
        headersExt: {
            'Content-Type': 'multipart/form-data'
        },
        params: {
            name: data.name,
            description: data.description,
            parentCategoryId: data.parentId,
            image: data.image
        }
    });
}

export async function getCategories(isAllCategories: boolean = false) {
    const producerId = localStorage.getItem("producerId");

    return baseCall({
        endpoint: Endpoints.categories,
        params: {
            producer: producerId,
            notProducer: isAllCategories
        }
    });
}

export async function getMediaNew(userType: string, page: number) {
    return baseCallNew({
        method: "GET",
        endpoint: userType === "seller" ? EndpointsNew.media_mine : EndpointsNew.media,
        params: {
            limit: 20,
            page
        }
    })
}

export async function moveProductBefore({productId, targetId}: { productId: string, targetId: string }) {
    return baseCallNew({
        method: "POST",
        endpoint: EndpointsNew.product_move_before,
        params: {
            productId,
            targetId
        }
    })
}

export async function moveProductAfter({productId, targetId}: { productId: string, targetId: string }) {
    return baseCallNew({
        method: "POST",
        endpoint: EndpointsNew.product_move_after,
        params: {
            productId,
            targetId
        }
    })
}

export async function getCategoriesNew({page}: { page: number }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.categories,
        params: {
            limit: 10,
            page
        }
    });
}

export async function getCategoriesAllNew() {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.categories_all
    });
}

export async function getProducersNew({page}: { page: number }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.producer,
        params: {
            limit: 10,
            page
        }
    });
}

export async function getProducersMinify() {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.producer_minify,
    });
}

export async function getProducersNewById({id}: { id: string }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.producer,
        id
    });
}

export async function getUsersNew({page}: { page: number }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.profile,
        params: {
            limit: 10,
            page
        }
    });
}

export async function getUsersNewById({id}: { id: string }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.profile,
        id
    });
}

export async function getCategoriesByIdNew(id: string | undefined) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.categories,
        id
    });
}


export async function getLotsNew({page}: { page: number }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.product_lot,
        params: {
            limit: 10,
            page: page
        }
    });
}

export async function getLotsByIdNew(id: string) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.product_lot,
        id
    });
}

export async function deleteLotNew(id: string) {
    return baseCallNew({
        method: "DELETE",
        endpoint: EndpointsNew.product_lot,
        id
    });
}

export async function getLotsMineNew({page}: { page: number }) {
    return baseCallNew({
        method: "GET",
        endpoint: EndpointsNew.product_lot_mine,
        params: {
            limit: 10,
            page: page
        }
    });
}

export async function getEvent(id?: string) {
    return baseCall({
        endpoint: Endpoints.events,
        type: "RESTAPI",
        id
    });
}

export async function getEventNew(id?: string) {
    return baseCallNew({
        endpoint: EndpointsNew.event,
        id
    });
}

export async function deleteMediaNew(id: string) {
    return baseCallNew({
        endpoint: EndpointsNew.media,
        method: "DELETE",
        id
    });
}

export async function getEvents() {
    return baseCall({
        endpoint: Endpoints.events_mine,
        type: "RESTAPI"
    });
}

export async function getEventsNew({page, archived}: { page: number, archived: boolean }) {
    return baseCallNew({
        endpoint: EndpointsNew.event_mine,
        params: {
            limit: 10,
            page,
            archived
        }
    });
}

export async function addEvent(data: EventQueryParams) {
    return baseCall({
        endpoint: Endpoints.event,
        type: "RESTAPI",
        method: "POST",
        data
    })
}

export async function addEventNew(data: EventQueryParamsNew) {
    return baseCallNew({
        endpoint: EndpointsNew.event,
        method: "POST",
        data
    })
}

export async function editEventNew(id: string, data: EventQueryParamsNew) {
    const editModel: EventQueryParamsNew = {
        title: notEmptyOrUndefined(data?.title),
        description: notEmptyOrUndefined(data?.description),
        startDate: notEmptyOrUndefined(data?.startDate),
        endDate: notEmptyOrUndefined(data?.endDate),
        location: notEmptyOrUndefined(data?.location),
        contactEmail: notEmptyOrUndefined<string>(data?.contactEmail),
        contactPhone: notEmptyOrUndefined(data?.contactPhone),
        contactWeb: notEmptyOrUndefined(data?.contactWeb),
        price: notEmptyOrUndefined(data?.price),
        long: notEmptyOrUndefined(data?.long),
        lat: notEmptyOrUndefined(data?.lat),
        mediaList: notEmptyOrUndefined(data?.mediaList),
        archived: notEmptyOrUndefined(data?.archived),
    }

    return baseCallNew({
        endpoint: EndpointsNew.event,
        method: "PUT",
        data: editModel,
        id
    });
}

export async function registerProducerNew(data: ProducerModelQueryParamsNew) {
    const registrationModel: ProducerRegistrationModelQueryParamsNew = {}
}

export async function registerProducer(data: ProducerModelQueryParamsNew) {
    const registrationModel: ProducerRegistrationModelQueryParamsNew = {
        email: data.email,
        password: data.password,
        producer: {
            name: data.name,
            description: data.description,
            website: data.website,
            address: data.address,
            phone: data.phone,
            piva: data.piva,
            contactEmail: data.contactEmail || data.email,
            referentName: data.referentName,
            referentSurname: data.referentSurname,
            referentEmail: data.referentEmail,
            referentPhone: data.referentPhone,
            // images: [`true&${data?.logoUpload?.imageBase64}`,
            //     ...data?.imagesUpload?.map((value) => value?.imageBase64) || []
            // ]
        }
    }

    return baseCallNew({
        endpoint: EndpointsNew.register_producer,
        method: "POST",
        data: registrationModel
    });
}

export async function getProductsNew({id, userType, page, producerId, categoryId, search, archived}: {
    id?: string,
    userType?: string,
    page: number,
    producerId?: string,
    categoryId?: string,
    search?: string,
    archived?: boolean,
}) {
    return baseCallNew({
        endpoint: userType === "seller" ? EndpointsNew.product_mine : EndpointsNew.product,
        method: "GET",
        params: {
            limit: 10,
            page,
            producerId,
            categoryId,
            search,
            archived
        }
    })
}

export async function getProductsById({id}: { id?: string }) {
    return baseCallNew({
        endpoint: EndpointsNew.product,
        method: "GET",
        id
    })
}

export async function getProductsMinifyNew({id, userType}: { id?: string, userType?: string | null }) {
    return baseCallNew({
        // endpoint: userType === "seller" ? EndpointsNew.product_mine : EndpointsNew.product,
        endpoint: userType === "admin" ? EndpointsNew.product_minify : EndpointsNew.product_mine_minify,
        method: "GET",
    })
}

export async function getProductCount() {
    return baseCallNew({
        endpoint: EndpointsNew.product_count,
        method: "GET",
    })
}

export async function deleteProduct(id: string) {
    return baseCallNew({
            endpoint: EndpointsNew.product,
            method: "DELETE",
            id
        }
    )
}

export async function deleteMedia(id: string, url?: string) {
    if(url) {
        await deleteMediaFromServer(url);
    }

    return baseCallNew({
            endpoint: EndpointsNew.media,
            method: "DELETE",
            id
        }
    )
}

export async function deleteUser(id: string) {
    return baseCallNew({
            endpoint: EndpointsNew.profile,
            method: "DELETE",
            id
        }
    )
}

export async function deleteCategory(id: string) {
    return baseCallNew({
            endpoint: EndpointsNew.categories,
            method: "DELETE",
            id
        }
    )
}

export async function deleteProducerNew(id: string) {
    return baseCallNew({
            endpoint: EndpointsNew.producer,
            method: "DELETE",
            id
        }
    )
}

export async function deleteEventNew(id: string) {
    return baseCallNew({
            endpoint: EndpointsNew.event,
            method: "DELETE",
            id
        }
    )
}

export async function addProduct(data: ProductQueryParams) {
    return baseCallNew({
        endpoint: EndpointsNew.product,
        method: "POST",
        data
    })
}

export async function editProductNew(id: string, data: ProductQueryParams) {
    return baseCallNew({
        endpoint: EndpointsNew.product,
        method: "PUT",
        data,
        id
    })
}

export async function editProducerNew(id: string, data: ProducerModelQueryParamsNew) {
    return baseCallNew({
        endpoint: EndpointsNew.producer,
        method: "PUT",
        data,
        id
    })
}

export async function addProducerNew(data: ProducerModelQueryParamsNew) {
    return baseCallNew({
        endpoint: EndpointsNew.producer,
        method: "POST",
        data
    })
}

export async function editUserNew(id: string, data: UserModelQueryParamsNew) {
    return baseCallNew({
        endpoint: EndpointsNew.profile,
        method: "PUT",
        data,
        id
    })
}

export async function getFeatured() {
    return baseCallNew({
        endpoint: EndpointsNew.featured,
        method: "GET",
    });
}

export async function addFeatured(data: FeaturedInputModel) {
    return baseCallNew({
        endpoint: EndpointsNew.featured,
        method: "POST",
        data,
    });
}

export async function editFeatured(id: string, data: FeaturedInputModel) {
    return baseCallNew({
        endpoint: EndpointsNew.featured,
        method: "PUT",
        data,
        id
    });
}

export async function deleteFeatured(id: string) {
    return baseCallNew({
        method: "DELETE",
        endpoint: EndpointsNew.featured,
        id
    });
}

export async function getMineProducer() {
    // return baseCall({
    //     endpoint: Endpoints.producer_mine,
    //     type: "RESTAPI",
    //     method: "GET"
    // });
    return baseCallNew({
        endpoint: EndpointsNew.producer_mine,
        method: "GET"
    });
}

export async function editUser(id: number | undefined) {
    if (!id) return undefined;

    const data = {
        roles: ["shop_manager"]
    };

    return baseCall({method: "PUT", id, endpoint: Endpoints.users, data, hasAuth: true});
}

export async function createCustomer(model?: ProducerModelQueryParams) {
    if (!model) return undefined;

    const {logoFile, ...other} = model || {};

    let finalModel: ProducerModelQueryParams = other;

    if (logoFile) {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result;
            reader.readAsDataURL(logoFile);

            finalModel = {logo: base64String, ...other};
        }
    }

    /*return await baseCall({
        method: "POST",
        type: "RESTAPI",
        endpoint: Endpoints.shop_manager,
        hasAuth: true,
        data: model
    }).then(value => {
        const response = value?.data as BaseResponse || {};
        if (response.code === 201) return true;
        else return response?.message;
    });*/

    /*baseCall({method: "POST", data: customerModel, endpoint: Endpoints.customers, hasAuth: true}).then(value => {
        const customer = (value?.data as PostCustomerResponse) || {};
        const id = customer.id;
        editUser(id).then(() => {
            getToken(model?.username || "", model?.password || "").then(tokenModel => {
                const response = (tokenModel?.data as TokenResponse) || {};
                const token = response.data?.token;

                const producerModel = producerToProducerModel(model);

                return baseCall({
                    type: "WP",
                    endpoint: Endpoints.producer,
                    method: "POST",
                    data: producerModel,
                    token
                })
            });
        });
    });*/
}
